export const Keys = {
    urlEncodedKey: "%3D",
    equal: "=",
    update_password: "update_password",
    delete: 'delete',
    AZURE_VIRTUAL_NETWORKS: 'virtualNetworks',
    RESOURCE_GROUPS: 'resourceGroups'
}

export const ErrorMessages = {
    SUBSCRIPTION_NOT_FOUND: "Could not find any matching subscription.",
    PEERING_EXISTS: "Peering already exists for the same customer VNET Resource ID. Delete that first and try again."
}

export const Regex = {
    ip: '^([0-9]{1,3}\.){3}[0-9]{1,3}$',
    awsOwnerIdPattern: '^[0-9]{12}$',
    awsVpcIdPattern: '^vpc-.*',
    awsCidrBlockPattern: '^([0-9]{1,3}\\.){3}[0-9]{1,3}/[0-9]{1,2}$',
    azureCidrBlockPattern:'^((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])/(3[0-2]|[1-2]?[0-9])$',
    azureOwnerIdPattern: '^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$',
    azureResourceGroupPattern:'^[a-zA-Z0-9]([-a-zA-Z0-9_]*[a-zA-Z0-9]){0,88}$',
    environmentName: '^[a-zA-Z][a-zA-Z0-9_-]{0,14}$',
    subscriptionId: /^[0-9a-zA-Z]{8}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{12}$/,
    guid: /^[0-9a-zA-Z]{8}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{4}-[0-9a-zA-Z]{12}$/,
    companyUrlPattern: /^(https?:\/\/)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,63}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/,
    integerRegex:/^\d+$/,
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    ipv4: /^((25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)$/,
    cidrBlock: /^((25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|1?[0-9][0-9]?)\/(3[0-2]|[1-2]?[0-9])$/,
    multipleSpaces: "/\\s{2,}/",
    missingComma: "/[^,\\s]+\\s+[^,\\s]+/"
}

export const ToolTip = {
    CUSTOMER_TENANT_ID: "Azure Tenant ID (Directory ID) in which your VNET is provisioned.",
    GUEST_USER_EMAIL: "Email address (User principal name) of the User you want to add as a guest in our Tenant.",
    CUSTOMER_CIDR: "CIDR block of your VNET. To find the CIDR block, go to the Azure portal, navigate to the Virtual Network page, select your VNET, go to Overview and copy the address space.",
    VNET_RESOURCE_ID: "Resource ID of your VNET. To find the VNET Resource ID, go to the Azure portal, navigate to the Virtual Networks page, select your VNET, then go to Settings > Properties and copy the Resource ID.",
    REGION: "Region in which the resources will be deployed.",
    ENVIRONMENT_CIDR: "CIDR block of the VNET of NCache Servers."
}


